import { Controller } from "@hotwired/stimulus"

const PANDADOC_ORIGIN = "https://app.pandadoc.com"
const COMPLETED_EVENT = "session_view.document.completed"

// Retour visuel instantané au clic sur « Terminer » dans l'iframe PandaDoc.
//
// PandaDoc poste `session_view.document.completed` à la page parente au moment même du clic, alors
// que le webhook qui valide l'étape met ~12 s à revenir (mesuré en review app : la livraison qui
// exécute `set_as_signed` a duré 11 994 ms — téléchargement du PDF signé, puis `activate` qui génère
// les attestations en synchrone). Sans ce contrôleur, l'utilisateur regarde un document déjà signé
// pendant douze secondes sans savoir si son clic a été pris en compte.
//
// C'est PUREMENT présentationnel : on ne valide rien, on ne soumet rien. L'étape ne peut pas être
// franchie avant que le serveur ait committé `status: signed` (la validation l'exige), et un submit
// anticipé échouerait puis re-rendrait l'étape — donc écraserait cet état d'attente. L'avancement
// reste piloté par la diffusion du webhook (cf. signature_auto_advance_controller.js).
export default class extends Controller {
  static targets = ["signing", "pending"]
  static values = { documentUuid: String }

  connect() {
    this.boundHandleMessage = this.handleMessage.bind(this)
    window.addEventListener("message", this.boundHandleMessage)
  }

  disconnect() {
    window.removeEventListener("message", this.boundHandleMessage)
  }

  handleMessage(event) {
    if (event.origin !== PANDADOC_ORIGIN) return

    const message = this.parseMessage(event.data)
    if (!message) return

    // PandaDoc envoie chaque événement DEUX fois : une chaîne JSON `{event, data}` (forme
    // historique) puis un objet `{type, payload}`. On lit les deux formes, et #showPending est
    // idempotent puisqu'on réagit donc deux fois par signature.
    if ((message.type || message.event) !== COMPLETED_EVENT) return

    const payload = message.payload || message.data || {}
    // `payload.uuid` est l'id du document PandaDoc, c'est-à-dire notre `signature_service_uuid`
    // (vérifié en review app). Un uuid qui n'est pas le nôtre ne nous concerne pas ; un payload
    // sans uuid reste accepté, l'iframe de cette étape étant la seule de la page.
    if (payload.uuid && this.documentUuidValue && payload.uuid !== this.documentUuidValue) return

    this.showPending()
  }

  parseMessage(data) {
    if (typeof data === "string") {
      try {
        return JSON.parse(data)
      } catch (_error) {
        return null
      }
    }

    return data && typeof data === "object" ? data : null
  }

  showPending() {
    this.signingTargets.forEach((element) => element.classList.add("d-none"))
    this.pendingTargets.forEach((element) => element.classList.remove("d-none"))
  }
}
